import { render, staticRenderFns } from "./hsnp_wizard_step_02_purchase_relative.vue?vue&type=template&id=0bbf8215&scoped=true"
import script from "./hsnp_wizard_step_02_purchase_relative.vue?vue&type=script&lang=js"
export * from "./hsnp_wizard_step_02_purchase_relative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf8215",
  null
  
)

export default component.exports